"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Sidebar_1 = require("../../Sidebar");
const utilities_1 = require("../../utilities");
const utilities_2 = require("../../Themes/utilities");
const polished_1 = require("polished");
const Items_1 = tslib_1.__importDefault(require("./Items"));
const react_media_1 = tslib_1.__importDefault(require("react-media"));
const react_1 = tslib_1.__importDefault(require("react"));
const js_cookie_1 = tslib_1.__importDefault(require("js-cookie"));
const navigationConfig_1 = tslib_1.__importDefault(require("./navigationConfig"));
const styled_components_1 = tslib_1.__importStar(require("../../Themes/styled-components"));
const Wrapper = styled_components_1.default.nav `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.navigation.backgroundColor};
  overflow-x: hidden;
  z-index: ${navigationConfig_1.default.BASE_ZINDEX + 2};
  transition: margin-left ${Sidebar_1.SIDEBAR_TRANSITION}, width ${Sidebar_1.SIDEBAR_TRANSITION};

  /* border cannot be used due to shrinked item mouseleave would be triggered */
  box-shadow: inset -1px 0 0 0 ${({ theme }) => theme.separatorColor};

  /* mobile */
  width: 100%;
  margin-left: -100%;
  ${({ $visible }) => $visible &&
    (0, styled_components_1.css) `
      margin-left: 0;
    `}
  /* tablet */
  ${(0, utilities_2.mb)('s')} {
    margin-left: ${({ theme }) => (0, polished_1.rem)(-theme.navigation.width)};
    width: ${({ theme }) => (0, polished_1.rem)(theme.navigation.width)};
    min-width: ${({ theme }) => (0, polished_1.rem)(theme.navigation.width)};

    ${({ $visible }) => $visible &&
    (0, styled_components_1.css) `
        margin-left: 0;
      `}
  }
  /* desktop */
  ${(0, utilities_2.mb)('xl')} {
    position: static;
    margin-left: ${({ theme }) => (0, polished_1.rem)(-theme.navigation.width)};
    width: ${({ theme }) => (0, polished_1.rem)(theme.navigation.width)};
    min-width: ${({ theme }) => (0, polished_1.rem)(theme.navigation.width)};

    ${({ $visible }) => $visible &&
    (0, styled_components_1.css) `
        margin-left: 0;
      `}

    ${({ $shrunkAvailable, $visible }) => $shrunkAvailable &&
    !$visible &&
    (0, styled_components_1.css) `
        margin-left: 0;
        width: ${({ theme }) => (0, polished_1.rem)(theme.navigation.shrunkWidth)};
        min-width: ${({ theme }) => (0, polished_1.rem)(theme.navigation.shrunkWidth)};
      `}
  }
`;
const Backdrop = styled_components_1.default.div `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${navigationConfig_1.default.BASE_ZINDEX};
  background-color: ${Sidebar_1.SIDEBAR_BACKDROP_BACKGROUND};
  transition: opacity ${Sidebar_1.SIDEBAR_TRANSITION};

  pointer-events: none;
  opacity: 0;

  ${({ $visible }) => $visible &&
    (0, styled_components_1.css) `
      pointer-events: initial;
      opacity: 1;
      ${(0, utilities_2.mb)('xl')} {
        pointer-events: none;
        opacity: 0;
      }
    `}
`;
const Navigation = ({ children, visible, items, renderLink, onClose, }) => {
    const [canShrunkBeActivated, setCanShrunkBeActivated] = react_1.default.useState(() => js_cookie_1.default.get(navigationConfig_1.default.NAVIGATION_SHRUNK_MATCHES_COOKIE_KEY) ===
        '1');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Wrapper, { "$visible": visible, "$shrunkAvailable": items.length > 0 }, items.length > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
            (0, utilities_1.isBrowser)() && (react_1.default.createElement(react_media_1.default, { query: `(min-width: ${utilities_2.mediaSizes.xl}px)`, onChange: matches => {
                    setCanShrunkBeActivated(matches);
                    js_cookie_1.default.set(navigationConfig_1.default.NAVIGATION_SHRUNK_MATCHES_COOKIE_KEY, matches ? '1' : '0');
                } })),
            react_1.default.createElement(Items_1.default, { items: items, shrunk: canShrunkBeActivated ? !visible : false, renderLink: renderLink }))) : (children || null)),
        react_1.default.createElement(Backdrop, { "$visible": visible, onClick: onClose, className: "Ui-TheLayout-Navigation-Backdrop" })));
};
Navigation.defaultProps = {
    visible: false,
};
exports.default = (0, styled_components_1.withTheme)(Navigation);
